/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Status_S1Inputs */

const en_vc_status_s1 = /** @type {(inputs: Vc_Status_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`of Illustrator's core menu items, tools, effects and formats exist`)
};

const zh_vc_status_s1 = /** @type {(inputs: Vc_Status_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Illustrator 的核心菜单项、工具、效果和格式已实现`)
};

/**
* | output |
* | --- |
* | "of Illustrator's core menu items, tools, effects and formats exist" |
*
* @param {Vc_Status_S1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_status_s1 = /** @type {((inputs?: Vc_Status_S1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Status_S1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_status_s1(inputs)
	return zh_vc_status_s1(inputs)
});
export { vc_status_s1 as "vc.status.s1" }